module.exports = __webpack_public_path__ + "fonts/HELVETICA_LT_CONDENSED_BOLD.a50f5700.ttf";